import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IconSun, IconMoon, IconDeviceDesktop } from "@tabler/icons-react";
import { LangConstant } from "const";
import { EventBusUtils } from "utils";

const resolveTheme = (mode) => {
  if (mode === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return mode;
};

const ChangeThemeForm = () => {
  const { t: getLabel } = useTranslation();

  const [themeMode, setThemeMode] = useState(() => {
    return localStorage.getItem("tabler_theme") || "system";
  });

  const handleSelectTheme = (newMode) => {
    setThemeMode(newMode);
    localStorage.setItem("tabler_theme", newMode);
    const resolved = resolveTheme(newMode);
    document.body.setAttribute("data-bs-theme", resolved);
    EventBusUtils.emit("changeTheme", resolved);
  };

  // Listen for OS theme changes when in "system" mode
  useEffect(() => {
    if (themeMode !== "system") return;
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = () => {
      const resolved = resolveTheme("system");
      document.body.setAttribute("data-bs-theme", resolved);
      EventBusUtils.emit("changeTheme", resolved);
    };
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [themeMode]);

  return (
    <div>
      <h4 className="mb-3">{getLabel(LangConstant.TXT_THEME_CONFIG)}</h4>
      <div className="row g-3">
        <div className="col-4">
          <label className="form-selectgroup-item w-100">
            <input
              type="radio"
              name="theme"
              value="system"
              className="form-selectgroup-input"
              checked={themeMode === "system"}
              onChange={() => handleSelectTheme("system")}
            />
            <span className="form-selectgroup-label d-flex align-items-center justify-content-center p-3 border rounded gap-2" style={{ cursor: "pointer", transition: "all 0.2s" }}>
              <IconDeviceDesktop size={18} className="text-secondary" />
              <strong>{getLabel(LangConstant.TXT_THEME_SYSTEM)}</strong>
            </span>
          </label>
        </div>
        <div className="col-4">
          <label className="form-selectgroup-item w-100">
            <input
              type="radio"
              name="theme"
              value="light"
              className="form-selectgroup-input"
              checked={themeMode === "light"}
              onChange={() => handleSelectTheme("light")}
            />
            <span className="form-selectgroup-label d-flex align-items-center justify-content-center p-3 border rounded gap-2" style={{ cursor: "pointer", transition: "all 0.2s" }}>
              <IconSun size={18} className="text-warning" />
              <strong>{getLabel(LangConstant.TXT_THEME_LIGHT)}</strong>
            </span>
          </label>
        </div>
        <div className="col-4">
          <label className="form-selectgroup-item w-100">
            <input
              type="radio"
              name="theme"
              value="dark"
              className="form-selectgroup-input"
              checked={themeMode === "dark"}
              onChange={() => handleSelectTheme("dark")}
            />
            <span className="form-selectgroup-label d-flex align-items-center justify-content-center p-3 border rounded gap-2" style={{ cursor: "pointer", transition: "all 0.2s" }}>
              <IconMoon size={18} className="text-info" />
              <strong>{getLabel(LangConstant.TXT_THEME_DARK)}</strong>
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ChangeThemeForm;
